import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";

class WorkshopCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            id: this.props.match.params.id,
            name: '',
            code: '',
            sortOrder: '',
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onCreate = (event) => {
        var url = "/api/category";
        let token = sessionStorage.getItem('accessToken');

        var data = {
            categoryName: this.state.name,
            categoryCode: this.state.code,
            sortOrder: this.state.sortOrder,
        }
        axios(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },data})
        .then(response => {
            console.log("response: " + response);
            if (response.status === 200) {
                this.props.history.goBack();
            }
        });
    }

    onUpdate = (event) => {
        var url = "/api/category/" + this.state.id;
        let token = sessionStorage.getItem('accessToken');

        var data = {
            categoryName: this.state.name,
            categoryCode: this.state.code,
            sortOrder: this.state.sortOrder,
        }
        axios(url, 
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }, 
            data})
        .then(response => {
            console.log("response: " + response);
            if (response.status === 200) {
                this.props.history.goBack();
            }
        });
    }

    componentDidMount() {
        if (this.props.match.params.id !== undefined) {
            var url = "/api/category/" + this.props.match.params.id;

            axios.get(url)
                .then((p) => {
                    console.log(p);
                    this.setState({
                        id: p.data.category.ID,
                        name: p.data.category.categoryName,
                        code: p.data.category.categoryCode,
                        sortOrder: p.data.category.sortOrder,
                        modalMode: 'Update',
                        modalIsOpen: true
                    });
                });
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <ValidatorForm
                noValidate
                onSubmit={this.state.id === undefined ? this.onCreate : this.onUpdate}
            >
                <Fragment>
                    <PageHeader
                        title={"Workshop Category"}
                        cancel={this.props.history.goBack}
                        actionButtons={[{ label: this.state.id === undefined ? "Add" : "Update" }]}
                    />

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextValidator
                                label="Name"
                                type="text"
                                name='name'
                                value={this.state.name}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['Name is required']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextValidator
                                id="standard-basic"
                                label="Code"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.code}
                                name='code'
                                inputProps={{ maxLength: 1 }}
                                validators={['required']}
                                errorMessages={['Code is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextValidator
                                id="standard-basic"
                                label="Sort Order"
                                type="number"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.sortOrder}
                                name='sortOrder'
                                validators={['required', 'isNumber']}
                                errorMessages={['Sort order is required', 'Only numbers are allowed']}
                                fullWidth
                                required
                            />
                        </Grid>
                    </Grid>

                </Fragment>
            </ValidatorForm>
        );
    }
}

// export default WorkshopCategory;
export default withStyles(styles, { withTheme: true })(WorkshopCategory);
